import { serviceMaker, methods, api } from "./index.js";

export const getBillCycle = () =>
  serviceMaker(`/billcycle`, methods.GET, api.NGB);
export const getNoOfBillProfiles = () =>
  serviceMaker(`/billcycle/clientscount`, methods.GET, api.NGB);
export const createBillCycle = (data) =>
  serviceMaker(`/billcycle`, methods.POST, api.NGB, data);
export const getBillHistory = () =>
  serviceMaker(`/billhistory`, methods.GET, api.NGB);
export const getBillHistoryById = (id) =>
  serviceMaker(`/billhistory/${id}`, methods.GET, api.NGB);
export const createBillHistory = (payload) =>
  serviceMaker(`/billhistory`, methods.POST, api.NGB, payload);
export const updateBillHistoryById = (payload) =>
  serviceMaker(
    `/billhistory/${payload.id}`,
    methods.PUT,
    api.NGB,
    payload.data
  );
